import { environment } from '../environments/environment';
import { alignLocalApiHostWithPage } from './align-local-api-host';
import { setLauncherUrlFromEnv } from './core/runtime-launcher-url';

interface RuntimeAppConfig {
  apiUrl?: string;
  launcherApiUrl?: string;
  otherAppUrl?: string;
}

/**
 * En intégration, `assets/app-config.json` peut être réécrit au démarrage du conteneur (Docker).
 * En local sur le LAN, l'hôte API suit l'IP de la page (IP dynamique).
 */
export function loadRuntimeConfig(): () => Promise<void> {
  return () => {
    alignLocalApiHostWithPage();
    setLauncherUrlFromEnv(environment);

    if (!environment.useRuntimeConfig) {
      return Promise.resolve();
    }
    return fetch('/assets/app-config.json')
      .then((res) => {
        if (!res.ok) {
          console.warn(
            '[EasyLoc] app-config.json introuvable — utilisation des valeurs du build.'
          );
          return null;
        }
        return res.json() as Promise<RuntimeAppConfig>;
      })
      .then((cfg) => {
        if (!cfg) return;
        const patch: Partial<typeof environment> = {};
        if (typeof cfg.apiUrl === 'string' && cfg.apiUrl.trim().length > 0) {
          patch.apiUrl = cfg.apiUrl.trim();
        }
        if (typeof cfg.launcherApiUrl === 'string' && cfg.launcherApiUrl.trim().length > 0) {
          patch.launcherApiUrl = cfg.launcherApiUrl.trim();
        }
        if (typeof cfg.otherAppUrl === 'string' && cfg.otherAppUrl.trim().length > 0) {
          patch.otherAppUrl = cfg.otherAppUrl.trim();
        }
        if (Object.keys(patch).length > 0) {
          Object.assign(environment, patch);
        }
        alignLocalApiHostWithPage();
        setLauncherUrlFromEnv(environment);
      })
      .catch(() => {
        console.warn('[EasyLoc] Erreur réseau lors du chargement de app-config.json.');
        setLauncherUrlFromEnv(environment);
      });
  };
}
